import { RequestActionType } from '../actions/requestActions';
import { ErrorType } from '../models/commonModels';

export interface RequestState {
    loading: boolean;
    error?: ErrorType;
}

const initialStateObject: RequestState = {
    loading: false,
    error: undefined,
};

export enum RequestType {
    ConfirmResetPassword = 'CONFIRM_RESET_PASSWORD',
    GetInviteInfo = 'GET_INVITE_INFO',
    GetUserConsentForClient = 'GET_USER_CONSENT_FOR_CLIENT',
    Initialize = 'INITIALIZE',
    Login = 'LOGIN',
    LogOut = 'LOGOUT',
    LogOutAllUnits = 'LOGOUT_ALL_UNITS',
    RegisterConsent = 'REGISTER_CONSENT',
    RegisterUser = 'REGISTER_USER',
    ResentConfirmationCode = 'RESEND_CONFIRMATION_CODE',
    ResetPassword = 'RESET_PASSWORD',
    VerifyEmail = 'VERIFY_EMAIL',
    ExchangeSsoToken = 'EXCHANGE_SSO_TOKEN',
    CheckTermsAndConditions = 'CHECK_TERMS_AND_CONDITIONS',
    SetTermsAndConditions = 'SET_TERMS_AND_CONDITIONS',
}

export interface CommonActionRequestType {
    requestActionType: RequestActionType;
    requestType: RequestType;
}

export type CommonsRequestStore = {
    [K in RequestType]: RequestState;
};

export const initialStore: CommonsRequestStore = {
    [RequestType.ConfirmResetPassword]: initialStateObject,
    [RequestType.GetInviteInfo]: initialStateObject,
    [RequestType.GetUserConsentForClient]: initialStateObject,
    [RequestType.Initialize]: initialStateObject,
    [RequestType.Login]: initialStateObject,
    [RequestType.LogOut]: initialStateObject,
    [RequestType.LogOutAllUnits]: initialStateObject,
    [RequestType.RegisterConsent]: initialStateObject,
    [RequestType.RegisterUser]: initialStateObject,
    [RequestType.ResentConfirmationCode]: initialStateObject,
    [RequestType.ResetPassword]: initialStateObject,
    [RequestType.VerifyEmail]: initialStateObject,
    [RequestType.ExchangeSsoToken]: initialStateObject,
    [RequestType.CheckTermsAndConditions]: initialStateObject,
    [RequestType.SetTermsAndConditions]: initialStateObject,
};

const requestReducer = (store: RequestState, action: RequestActionBase): RequestState => {
    switch (action.requestActionType) {
        case RequestActionType.Init:
            return {
                ...store,
                loading: true,
                error: undefined,
            };
        case RequestActionType.Success:
            return {
                ...store,
                loading: false,
                error: undefined,
            };
        case RequestActionType.Error:
            return {
                ...store,
                loading: false,
                error: action.error,
            };
        case RequestActionType.ClearError:
            return {
                ...store,
                loading: false,
                error: undefined,
            };
        default:
            return {
                ...store,
            };
    }
};

interface RequestActionBase {
    requestType: string;
    requestActionType: string;
    error?: ErrorType;
}

export const reducer =
    <RequestStore extends Record<string, RequestState>, RequestAction extends RequestActionBase>(
        initStore: RequestStore
    ) =>
    (store: RequestStore = initStore, action: RequestAction): RequestStore => {
        if (!(action.requestType in initStore)) return store;

        return {
            ...store,
            [action.requestType]: {
                ...requestReducer(store[action.requestType], action),
            },
        };
    };

export default reducer(initialStore);
